// https://blog.angular-university.io/angular-custom-form-controls/

import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { forEach, get } from '@sama/micro-dash';
import { provideValueAccessor } from '@sama/ng-core';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';
import { ObjectWith } from '../../../../cross-team-shared/types/misc';
import { AbstractFormControl } from '../../../../shared/forms/basic-inputs/abstract-form-control';
import { AnswerOption } from '../../../../team-apis/otterdam/answer-option';
import { CheckboxAnswer } from '../../../../team-apis/otterdam/answers/checkbox-answer';

type CheckboxItem = {
  checked$: BehaviorSubject<boolean>;
  option: AnswerOption;
};

@Component({
  selector: 'h3-checkbox-output-value-accessor',
  templateUrl: 'checkbox-output-value-accessor.component.html',
  styleUrls: ['checkbox-output-value-accessor.component.scss'],
  providers: [provideValueAccessor(CheckboxOuputValueAccessorComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckboxOuputValueAccessorComponent
  extends AbstractFormControl<ObjectWith<string>>
  implements OnInit
{
  @Input({ required: true })
  answerOptions!: AnswerOption[] | undefined;
  @Input({ required: true })
  name!: string;
  @Input({ required: true })
  trainingAnswers?: CheckboxAnswer;

  checkboxes$ = new BehaviorSubject<CheckboxItem[]>([]);

  ngOnInit() {
    const checkboxes: CheckboxItem[] = [];
    forEach(this.answerOptions, (option) => {
      checkboxes.push({
        checked$: new BehaviorSubject(false),
        option,
      });
    });
    this.checkboxes$.next(checkboxes);
  }

  valueHasChanged(checkbox: CheckboxItem) {
    checkbox.checked$.next(!checkbox.checked$.getValue());
    this.emitOutgoingValue(this.parseCheckboxes());
  }

  isChecked$(checkbox: CheckboxItem) {
    return checkbox.checked$.pipe(distinctUntilChanged());
  }

  override handleIncomingValue(newAnswer: ObjectWith<string>) {
    forEach(this.checkboxes$.getValue(), (checkbox) => {
      checkbox.checked$.next(
        this.parseAnswer(get(newAnswer, checkbox.option.name)),
      );
    });
  }

  private parseAnswer(answer: any) {
    return answer === '1' ? true : false;
  }

  private parseCheckboxes() {
    const answer: ObjectWith<string> = {};
    forEach(this.checkboxes$.getValue(), (checkbox) => {
      answer[checkbox.option.name] = checkbox.checked$.getValue() ? '1' : '0';
    });
    return answer;
  }
}
